import { render, staticRenderFns } from "./poas.vue?vue&type=template&id=239d583e&"
import script from "./poas.vue?vue&type=script&lang=ts&"
export * from "./poas.vue?vue&type=script&lang=ts&"
import style0 from "./poas.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports